import { render, staticRenderFns } from "./change-zone-page.vue?vue&type=template&id=48bae9a5&scoped=true&"
import script from "./change-zone-page.vue?vue&type=script&lang=js&"
export * from "./change-zone-page.vue?vue&type=script&lang=js&"
import style0 from "./change-zone-page.vue?vue&type=style&index=0&id=48bae9a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bae9a5",
  null
  
)

export default component.exports